// Wrong-try delay (Implementation Plan v02 §6.2, IR-22; I-1a Batch 3 plan).
//
// A growing delay after wrong tries, shown calmly; Help now and Hide stay
// reachable; NO auto-wipe (a person in distress must not lose the diary). The
// failed-try counter lives in the clear install record WITHOUT times, so after a
// reload the wait is counted from page load, using the stored count.
// The Argon2id floor (~1 s per try) is itself a rate limit on top of this.

const LADDER_SECONDS: readonly number[] = [0, 0, 0, 5, 15, 30, 60, 120]
export const MAX_DELAY_SECONDS = 300

/** Seconds to wait before the next try, given how many tries have failed so far. */
export function unlockDelaySeconds(failedTries: number): number {
  if (!Number.isFinite(failedTries) || failedTries <= 0) {
    return 0
  }
  const n = Math.floor(failedTries)
  return n < LADDER_SECONDS.length ? LADDER_SECONDS[n]! : MAX_DELAY_SECONDS
}
